import { FC, PropsWithChildren } from 'react';

import { useSpoofing } from '@bonusly/who-am-i';

import { FlaggedRoute } from '../components/routes/FlaggedRoute';
import { RequireAdmin } from '../components/routes/require-admin';

// We need to temporarily be able to view the analytics page while isSpoofing
// another user. This isn't an ideal solution and should be removed once we've
// confirmed the page is working correctly. The long term solution is to improve
// the web tools component to allow for granular access control.
export const TemporaryScoringAuth: FC<PropsWithChildren> = ({ children }) => {
	const { isSpoofing } = useSpoofing();

	if (isSpoofing) {
		return children;
	}

	return (
		<FlaggedRoute variant="recognition-quality-scoring-analytics">
			<RequireAdmin require="finance">{children}</RequireAdmin>
		</FlaggedRoute>
	);
};
